<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <base-input
          label="Tanggal"
          type="date"
          :shadow="false"
          v-model="filter.created_at_date"
          @change="loadErrors"
        />
        <base-input label="Status" :shadow="false" @change="loadErrors">
          <base-select
            :options="[
              { key: 'none', value: null, label: 'Semua' },
              {
                key: 'code_not_found',
                value: 'code_not_found',
                label: 'Kode tidak ditemukan',
              },
              {
                key: 'office_disabled',
                value: 'office_disabled',
                label: 'Kode tidak aktif',
              },
              {
                key: 'user_not_found',
                value: 'user_not_found',
                label: 'Kode tidak memiliki user',
              },
              {
                key: 'code_deleted',
                value: 'code_deleted',
                label: 'Kode dihapus',
              },
              {
                key: 'pin_changed',
                value: 'pin_changed',
                label: 'Password sudah diubah',
              },
              {
                key: 'pin_hash_mismatch',
                value: 'pin_hash_mismatch',
                label: 'Hash PIN dan password tidak sesuai',
              },
              {
                key: 'pin_mismatch',
                value: 'pin_mismatch',
                label: 'PIN salah',
              },
            ]"
            :shadow="false"
            v-model="filter.error_type"
            @change="loadErrors"
          />
        </base-input>
        <base-input
          label="Kode"
          type="text"
          placeholder="Cari Kode"
          :shadow="false"
          debounce
          v-model="filter.search_code"
          @native-input="loadErrors"
        />
        <base-input
          label="No. Telp"
          type="text"
          placeholder="Cari No. Telp"
          :shadow="false"
          debounce
          v-model="filter.search_phone"
          @native-input="loadErrors"
        />
      </div>
      <datatable
        :columns="columns"
        :total="errors.meta.page.total"
        :perPage="errors.meta.page.perPage"
        :currentPage="errors.meta.page.currentPage"
        :meta="errors.meta"
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="(item, index) in errors.data"
            :key="item.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">
              <base-checkbox
                v-model="errors.data[index].attributes.resolved"
                @change="onChangeResolved(index)"
              />
            </td>
            <td :class="classes.td">
              <span class="font-bold text-gray-900">{{
                item.attributes.code
              }}</span>
            </td>
            <td :class="classes.td">
              {{ item.attributes.updatedAt | formatDate }}
            </td>
            <td :class="classes.td">{{ item.attributes.text }}</td>
            <td :class="classes.td">{{ item.attributes.name ?? '-' }}</td>
            <td :class="classes.td">{{ item.attributes.phone ?? '-' }}</td>
          </tr>
        </template>
      </datatable>
    </div>

    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import BaseCheckbox from '../../../components/base/BaseCheckbox.vue';
import { requestMixin } from '../../../mixins/request/request';

export default {
  components: { BaseCheckbox },
  mixins: [requestMixin],
  data() {
    return {
      filter: {
        created_at_date: null,
        error_type: null,
        search_code: null,
        search_phone: null,
      },
      errors: {
        data: [],
        meta: {
          page: {},
        },
      },
      loading: false,
    };
  },
  computed: {
    columns() {
      return [
        { id: 'resolved', name: '' },
        { id: 'code', name: 'Kode' },
        { id: 'date', name: 'Tanggal' },
        { id: 'error', name: 'Error' },
        { id: 'name', name: 'Nama' },
        { id: 'phone', name: 'No. Telp' },
      ];
    },
  },
  methods: {
    async loadErrors(params) {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/check-mitra-usaha-errors`,
        {
          params: {
            'fields[check-mitra-usaha-errors]':
              'code,text,updatedAt,name,phone,resolved',
            'page[size]': 5,
            sort: '-id',
            'filter[created_at_date]': this.filter.created_at_date,
            'filter[error_type]': this.filter.error_type,
            'filter[search_code]': this.filter.search_code,
            'filter[search_phone]': this.filter.search_phone,
            ...params,
          },
        }
      );

      if (!err) {
        this.errors = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadErrors({
        'page[number]': page,
      });
    },
    async onChangeResolved(index) {
      const item = this.errors.data[index];

      this.loading = true;

      await this.request(`/api/v1/check-mitra-usaha-errors/${item.id}`, {
        method: 'patch',
        data: {
          data: {
            type: 'check-mitra-usaha-errors',
            id: item.id,
            attributes: {
              resolved_at: item.attributes.resolved ? new Date() : null,
            },
          },
        },
      });

      this.loading = false;
    },
  },
  created() {
    this.loadErrors();
  },
};
</script>
